import React from 'react'
import { Layout, ConfigProvider, Icon, Breadcrumb } from 'antd'
import { Redirect, Link } from 'react-router-dom'
import RightMenu from './RightMenu.js'
import Leftmenu from './LeftMenu.js'
import request from '@/common/urequest'
import common from '@/common/common.js'
import zhCN from 'antd/es/locale/zh_CN'

import '../css/main.less'
import './BaseLayou.less'

const { Header } = Layout;
export default class BaseLayout extends React.Component {
    state = {
        siderclass: "suosider",
        collapsed: false,
        prelocation: "",
        suologo: "logo",
        user: null,
        fetchingNotices: true,
        notices: [],
        count: 0,
        message: null,
        menus: [],
        childrenMenus: [],
        activeMenus: [],
        authUrls: common.getlocalItem('auth-menus') ? common.getlocalItem('auth-menus') : [],
        activeRootKey: null,

        activeMenu: null,
        activeRoot: null,

        indexUrl: null,

        bcList: [],
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.checkUrlRole(nextProps.location.pathname);
        }
    }

    updateActive = location => {
        if (location && location.state) {
            const { _mkey, _rkey } = location.state;
            if (_mkey) {
                this.setState({ activeMenu: _mkey });
            }
            if (_rkey) {
                this.setState({ activeRootKey: _rkey });
            }
        }
    }

    componentWillMount() {
        this.queryUserInfo();
        this.queryMenus();
    }

    toggle = () => {
        if (!this.state.collapsed) {
            this.setState({ suologo: "suologo", siderclass: "" });
        } else {
            this.setState({ suologo: "logo", siderclass: "suosider" });
        }
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    queryMenus = () => {
        let menus = [];
        const that = this;
        this.setState({ menus });

        request('appVendLogin/queryMenus.action', {
            method: 'POST',
            requestType: 'form'
        }).then(d => {
            if (d) {
                let currentId = null;//当前菜单的ID
                d.forEach(item => {
                    if (item.url) {
                        item['url'] = item.url.trim();
                    }
                });
                d.forEach(item => {
                    if (that.props.location.pathname === item.url && item.pid !== '#') {
                        currentId = item.id;
                    }
                });
                menus = that.groupMenus(d);
                let activeMenus = [];
                let activeRootKey = null;
                let activeMenu = null;
                if (menus.length > 0) {

                    activeMenus = menus[0].children;
                    activeRootKey = menus[0].id;
                    activeMenu = menus[0].id;

                    const user = common.getlocalItem('user-info');
                    if (user && user.index && currentId === user.index) {
                        let indexItem = that.getMenuParent(user.index, menus);
                        if (indexItem && indexItem.length > 1) {//最低选择2级菜单才生效
                            const rm = indexItem[indexItem.length - 1];
                            const cm = indexItem[indexItem.length - 2];
                            activeMenus = rm.children;
                            activeRootKey = rm.id;
                            activeMenu = cm.id;
                        }
                    } else {
                        let indexItem = that.getMenuParent(currentId, menus);
                        if (indexItem && indexItem.length > 1) {
                            const rm = indexItem[indexItem.length - 1];
                            const cm = indexItem[indexItem.length - 2];
                            activeMenus = rm.children;
                            activeRootKey = rm.id;
                            activeMenu = cm.id;
                        }
                    }
                    that.setState({ menus, authUrls: d, activeMenus, activeRootKey, activeMenu });
                }
                that.checkUrlRole(that.props.location.pathname);
            }
        });
    }

    getMenuParent = (id, menus = []) => {
        let parents = [];
        let group = (id, data = []) => {
            data.forEach(item => {
                if (id === item.id) {
                    parents.push(item);
                    if (id !== '#') {
                        group(item.pid, menus);
                    }
                } else {
                    group(id, item.children);
                }
            });
        }
        group(id, menus);
        return parents;
    }

    groupMenus = (data = []) => {
        let parents = data.filter(val => val.pid === '#');
        let childrens = data.filter(val => val.pid !== '#');
        this.setState({ childrenMenus: childrens });
        let group = (parents, childrens) => {
            parents.forEach(p => {
                childrens.forEach((c, index) => {
                    if (c.pid === p.id) {
                        let temp = childrens.concat([]);
                        temp.slice(index, 1);
                        group([c], temp);
                        typeof p.children !== 'undefined' ? p.children.push(c) : p['children'] = [c];
                    }
                });
            });
        }
        group(parents, childrens);
        return parents;
    }

    queryUserInfo = () => {
        const result = async () => {
            return request('mema/centerHonePage.action', {
                method: 'POST',
                requestType: 'form'
            });
        };
        result().then(d => {
            if (d != null) {
                this.setState({ user: d });
            }
        });

    }

    onMenuClick = (menu) => {
        if (menu.key === 'logout') {
            this.props.loginOut();
        }
    }

    flagMessage = id => {
        request('message/updateMesage.action', {
            method: 'POST',
            requestType: 'form',
            data: { 'message.id': id }
        }).then(d => {
            if (d) {
                if (d.status) {
                    console.log(d.info);
                }
            }
        });
    }

    onClick = (id, type) => {
        const that = this;
        const { toUrl } = this.props;
        request('message/updateMesage.action', {
            method: 'POST',
            requestType: 'form',
            data: { 'message.id': id },
        }).then(d => {
            if (d && d.status === "success") {
                that.setState({ message: null });
                that.queryCountMessage();
                toUrl({
                    pathname: "/message/detail",
                    state: {
                        id: id,
                        type: type
                    },
                });
            }
        });
    }

    cleanNewMessage = () => {
        this.setState({ message: null });
    }

    checkUrlRole = url => {
        if (url) {
            if (url === '/404' ||
                url === '/login' ||
                url === '/' ||
                url === '/success' ||
                url === '/closed') {
                return;
            }
            const { authUrls } = this.state;
            const { toUrl } = this.props;
            if (authUrls) {
                const names = this.getParentName(authUrls, url);
                this.setState({ bcList: names });
                let flag = false;
                for (let i = 0; i < authUrls.length; i++) {
                    if (url === authUrls[i].url) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    toUrl('/404');
                }
            }
        }
    }

    getParentName = (array, url) => {
        let names = [];
        let group = pid => {
            array.forEach(item => {
                if (item.id === pid) {
                    if (item.pid !== '#') {
                        group(item.pid);
                    }
                    names.push({ name: item.name, url: item.url });
                }
            });
        }
        array.forEach(item => {
            if (item.url && item.pid !== '#' && url === item.url.trim()) {
                group(item.pid);
                names.push({ name: item.name, url: item.url });
            }
        });
        // if (names && names.length > 1) {
        //     names.reverse();
        // }
        return names;
    }

    urlAuth = url => {
        if (url === '/404') {
            return true;
        }
        const { authUrls } = this.state;
        let falg = false;
        if (authUrls) {
            authUrls.forEach(item => {
                if (item.url === url) {
                    falg = true;
                }
            });
        }
        return falg;
    }

    activeMenus = (menus, rid) => {
        this.setState({ activeMenus: menus, activeRootKey: rid });
    }

    toIndex = () => {
        const { menus } = this.state;
        const user = common.getlocalItem('user-info');
        if (user && user.index && user.indexUrl) {
            this.props.history.push(user.indexUrl);
        } else {
            if (menus.length > 0) {
                if (menus[0].children) {
                    if (menus[0].children.length > 0) {
                        if (menus[0].children[0].url) {
                            this.props.history.push(menus[0].children[0].url);
                        }
                    }
                }

            }
        }
    }

    render() {
        const { user, collapsed, menus, activeMenus, activeRootKey, activeMenu, bcList } = this.state;
        const { children, location } = this.props;
        const { pathname } = location;
        let userInfo = common.getlocalItem('user-info');
        if (this.urlAuth(pathname)) {
            return (
                <ConfigProvider locale={zhCN}>
                    <Layout id="app-vend">
                        <Header style={{ background: '#03b8cc', padding: 0, color: "#fff", height: 41 }} className="header vend-header">
                            <div className={"logo " + (collapsed ? "hide" : "show")} onClick={() => this.toIndex()}>
                                {collapsed ? null : <span>{!user || user.companyName}</span>}
                            </div>
                            <Icon
                                className="trigger"
                                type={collapsed ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.toggle}
                            />
                            <div className="topmenuclass">
                                <RightMenu
                                    currentUser={user}
                                    history={this.props.history}
                                    onMenuClick={this.onMenuClick}
                                />
                            </div>
                            <div className="top-center-menus">
                                <ul>
                                    {
                                        menus && menus.length > 0 ? menus.map(item => (
                                            <li className={(activeRootKey && activeRootKey === item.id) ? 'active' : null} onClick={() => this.activeMenus(item.children, item.id)} key={item.id}>
                                                <span className="t-c-m-text">
                                                    {item.url ? <Link to={{
                                                        pathname: item.url
                                                    }}>{item.name}</Link> : item.name}
                                                </span>
                                                {
                                                    item.icon ? <i className={"iconfont " + item.icon}></i> : null
                                                }
                                            </li>
                                        )) : null
                                    }
                                </ul>
                            </div>
                        </Header>
                        <div className="v-warp">
                            <Leftmenu displayType={collapsed} menus={activeMenus} rootkey={activeRootKey} active={activeMenu} />
                            <div className={"main-wrap " + (collapsed ? "main-wrap-half" : "main-wrap-full")}>
                                <Breadcrumb className="v-breadcrumb">
                                    {bcList.map((item, index) => <Breadcrumb.Item key={index}>
                                        {
                                            item.url === null || index === bcList.length - 1 ? item.name :
                                                <Link to={{ pathname: item.url }}>
                                                    {item.name}
                                                </Link>
                                        }
                                    </Breadcrumb.Item>)}
                                </Breadcrumb>
                                {children}
                            </div>
                        </div>
                    </Layout>
                </ConfigProvider>
            )
        } else {
            if ((pathname === '/login' || pathname === '/') && userInfo) {
                return <Redirect to={userInfo.redirect} />
            } else {
                return <Redirect to="/404" />
            }
        }
    }
}